"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pluralize = exports.pluralize = function pluralize(count, string, plural) {
  return count === 1 ? string : plural || string + "s";
};

var pluralizeWithCount = exports.pluralizeWithCount = function pluralizeWithCount(count, string, plural) {
  return count + " " + pluralize(count, string, plural);
};